import { Row, Col } from "../RowCol";
import styled from "styled-components";

const RateCards = () => {
  return (
    <Row style={{ marginTop: "2%",marginbottom: "2%" }} className="service-rate">
      <Col area="span 3">
        <Card>
          <div style={{ display: "flex" }}>
            <img src="/img/success-black-check-mark.svg" alt="" />
            <H3>Doctors</H3>
          </div>
          <p
            style={{ marginTop: "5%", color: "#969696", fontWeight: "medium" }}
          >
           Serviceability
          </p>
          <ProgressBar color="orange" width="70%" />
        </Card>
      </Col>
      <Col area="span 3">
        <Card>
          <div style={{ display: "flex" }}>
            <img src="/img/success-black-check-mark.svg" alt="" />
            <H3>Clinics</H3>
          </div>
          <p
            style={{ marginTop: "5%", color: "#969696", fontWeight: "medium" }}
          >
            Proximity 
          </p>
          <ProgressBar color="green" width="10%" />
        </Card>
      </Col>
      <Col area="span 3">
        <Card>
          <div style={{ display: "flex" }}>
            <img src="/img/success-black-check-mark.svg" alt="" />
            <H3>Labs</H3>
          </div>
          <p
            style={{ marginTop: "5%", color: "#969696", fontWeight: "medium" }}
          >
            Serviceability
          </p>
          <ProgressBar color="blue" width="76%"  />
        </Card>
      </Col>
      <Col area="span 3">
        <Card>
          <div style={{ display: "flex" }}>
            <img src="/img/success-black-check-mark.svg" alt="" />
            <H3>Emergency</H3>
          </div>
          <p
            style={{ marginTop: "5%", color: "#969696", fontWeight: "medium" }}
          >
            Proximity 
          </p>
          <ProgressBar color="green" width="7%" />
        </Card>
      </Col>
    </Row>
  );
};

const H3 = styled.h3`
  margin-left: 10%;
  font-size: 2rem;
`;

const Card = styled.div`
  margin: 1rem;
  background-color: white;
  border-radius: 26px;
  box-shadow: 0px 3px 6px #00000029;
  padding: 10%;
`;

const progressColors = {
  green: "#01A601",
  pink: "#E87971",
  blue: "#05C4E2",
  orange: "#F66220",
};

const Progress = styled.div`
  height: 0.6rem;
  background-color: #ccd0d2;
  display: grid;
  grid-template-columns: ${(props) => props.width} calc(
      100% - ${(props) => props.width}
    );
  border-radius: 50px;
  width: 100%;
  margin-top: 1rem;
  .progress-item {
    height: 0.6rem;
    background-color: ${({ color }) => progressColors[color]};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-radius: 50px;
   
    span {
      font-size: 0.8rem;
      color: black;//rgb(192, 131, 62);
      //margin-top: -2rem;
    }
  }
  .bg {
    width: 100%;
  }
`;
const ProgressBar = ({ color, width }) => {
  return (
    <Progress color={color} width={width}>
      <div className="progress-item">
        <span>{width}</span>
      </div>
      <div className="bg"></div>
    </Progress>
  );
};

export default RateCards;
